import type {Values} from '@wix/devzai-utils-common';
import {enumGetValues} from '@wix/devzai-utils-common';

export const DoppePageLockBackgroundMode = {
    Blur: 'blur',
    Solid: 'solid',
    Gradient: 'gradient',
} as const;

export type DoppePageLockBackgroundMode = Values<typeof DoppePageLockBackgroundMode>;

export function doppePageLockBackgroundModeGetValuesForList() {
    return enumGetValues(DoppePageLockBackgroundMode);
}
